'use strict';
import 'browsernizr/test/svg';
export default class Svg {
  constructor(supports, el) {
    this.el = el;
    const pngFallback = el.dataset.pngFallback;
    if (!supports && pngFallback) {
      var image = document.createElement('img');
      image.src = pngFallback;
      image.onload = function() {
        el.replaceChild(image, el.childNodes[0]);
      };
    }
  }
}
